export const environment = {
  production: false,
  fileUpload: 'https://ee-staging-api.invenit.dev/api/files/upload/',
  fileDownload: 'https://ee-staging-api.invenit.dev/api/files/download/',
  apiUrl: 'https://ee-staging-api.invenit.dev/graphql',
  exportPdfUrl: 'https://ee-staging-api.invenit.dev/api/pdfexport/app/',
};
